import afcpe from './afcpe';
import micro from './afcpe/micro';
import dojoTheme from './dojo-theme';
export const fullTheme = {
    theme: Object.assign({}, dojoTheme.theme, afcpe.theme),
    variants: {
        default: dojoTheme.variants.default,
        afc1: afcpe.variants.afc1
    }
};
export const microTheme = {
    theme: Object.assign({}, dojoTheme.theme, micro.theme),
    variants: {
        default: dojoTheme.variants.default,
        mme1: micro.variants.mme1
    }
};
export default fullTheme;
